import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { StoreService } from "@root/shared/service/store.service";
import { InternationalService } from "@root/international.service";
export type Currency = "CNY" | "USD" | "";
export const StoreKey = "hostex_current_currency";
interface Data {
  currency_list: Array<Currency>;
}

interface Response {
  error_code: number;
  error_msg: string;
  data: Partial<Data>;
}

const GET_CURRENCY = "/api/transaction/get_currency";

@Injectable({
  providedIn: "root",
})
export class CurrencyService {
  private readonly storeKey = "hostex_current_currency";

  currencyRaw$ = new Subject<Currency>();

  constructor(
    private http: HttpClient,
    private storeService: StoreService,
    private international: InternationalService
  ) {}

  fetchCurrencyList(params = { only_in_record: 0 }) {
    const query = new HttpParams().append(
      "only_in_record",
      `${params.only_in_record}`
    );
    return this.http.get(GET_CURRENCY, { params: query }) as Observable<
      Response
    >;
  }

  changeCurrency(currency: Currency) {
    this.currencyRaw$.next(currency);
  }

  storeCurrencyToLocal(value) {
    this.storeService.set(this.storeKey, value, 2);
  }

  getCurrency() {
    return (
      this.storeService.get(this.storeKey, 2) ||
      this.international.getCurrency()
    );
  }
}
